import { render, staticRenderFns } from "./companyPerson.vue?vue&type=template&id=5be1d4e2&scoped=true"
import script from "./companyPerson.vue?vue&type=script&lang=js"
export * from "./companyPerson.vue?vue&type=script&lang=js"
import style0 from "./companyPerson.vue?vue&type=style&index=0&id=5be1d4e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be1d4e2",
  null
  
)

export default component.exports